export default __webpack_public_path__ + "static/Bigcommerce-b45552ff757cf315795730408efb75c1.png";